// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }
    on(event, handler) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, []);
        }
        this.listeners.get(event).push(handler);
        return () => {
            this.listeners.set(event, this.listeners.get(event).filter((item) => item !== handler));
        };
    }
    emit(event, ...data) {
        var _a;
        for (const handler of (_a = this.listeners.get(event)) !== null && _a !== void 0 ? _a : []) {
            handler(...data);
        }
    }
}
//# sourceMappingURL=event-emitter.js.map